export default ({ options, gameData }) => {
  return !(!options || !gameData);
};
